<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-position-warning`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M23 2c8.284 0 15 6.705 15 14.976C38 22.49 33 29.498 23 38 13 29.498 8 22.49 8 16.976 8 8.706 14.716 2 23 2zM10.766 36a1 1 0 01.978 1.207L10.728 42h26.543l-1.015-4.793a1 1 0 01-.016-.103L36.234 37a1 1 0 01.883-.993l.117-.007h1.956a1 1 0 01.947.68l.031.113L41.695 44h-.07l.153.815A1 1 0 0140.795 46H7.2a1 1 0 01-.983-1.18l.15-.82h-.062l1.527-7.207A1 1 0 018.81 36h1.956zM12 16.976C12 10.916 16.923 6 23 6c6.076 0 11 4.916 11 10.976 0 3.59-3.585 8.97-11 15.703-7.415-6.732-11-12.113-11-15.703zM25 21v4h-4v-4h4zm0-10a1 1 0 00-1-1h-2a1 1 0 00-1 1v7a1 1 0 001 1h2a1 1 0 001-1v-7z"/></svg>
</template>
<script>

export default {
  name: 'IconPositionWarning',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
